import React from 'react';
import {appConstants} from "../_constants";

export const DefaultLabel = ({message}) =>
{
    return  (<span
                style={{
                    cursor: "pointer", backgroundColor: `${appConstants.MUTED_COLOR}`,
                    borderRadius: "4px", padding: "0 15px 2px", color: "#ffffff"
                }}>
                {message}
            </span>)
};
export const PrimaryLabel = ({message}) =>
{
    return  (<span
                style={{
                    cursor: "pointer", backgroundColor: `${appConstants.PRIMARY_COLOR}`,
                    borderRadius: "5px", padding: "0 15px 2px", color: "#ffffff"
                }}>
                {message}
            </span>)
};
export const DangerLabel = ({message}) =>
{
    return  (<span
                style={{
                    cursor: "pointer", backgroundColor: `${appConstants.DANGER_COLOR}`,
                    borderRadius: "5px", padding: "0 15px 2px", color: "#ffffff"
                }}>
                {message}
            </span>)
};



// WEBPACK FOOTER //
// ./src/utils/LabelPanel.js